import { createAction, props } from '@ngrx/store';
import { UniversitySearchCondition, UniversityCondition, PrefectureCondition } from '../../models/university-search-condition';
import { CommonIdSearchCountResponse } from '../../models/common-id/common-id-search-count-response';
import { CommonIdFindUniversityPapersResponse } from '../../models/common-id/common-id-find-university-papers-response';

// 検索条件に合う大学の校数を取得する ------------------------------------------------------------
export const findUniversityCountByUniversityIds = createAction(
  '[Common ID Search] Find University Count By University Ids',
  props<{ condition: UniversitySearchCondition<UniversityCondition>; logging: boolean }>()
);
export const findUniversityCountByUniversityIdsSuccess = createAction(
  '[Common ID Search] Find University Count By University Ids Success',
  props<{ result: CommonIdSearchCountResponse }>()
);
export const findUniversityCountByUniversityIdsFailure = createAction('[Common ID Search] Find University Count By University Ids Failure');

// 検索条件に合う大学の校数を取得する（都道府県別） ------------------------------------------------------------
export const findUniversityCountByPrefectureIds = createAction(
  '[Common ID Search] Find University Count By Prefecture Ids',
  props<{ condition: UniversitySearchCondition<PrefectureCondition>; logging: boolean }>()
);
export const findUniversityCountByPrefectureIdsSuccess = createAction(
  '[Common ID Search] Find University Count By Prefecture Ids Success',
  props<{ result: CommonIdSearchCountResponse }>()
);
export const findUniversityCountByPrefectureIdsFailure = createAction('[Common ID Search] Find University Count By Prefecture Ids Failure');

// 検索条件に合う大学の詳細を取得する ------------------------------------------------------------
export const findUniversityPapersByUniversityIds = createAction(
  '[Common ID Search] Find University Papers By University Ids',
  props<{ condition: UniversitySearchCondition<UniversityCondition>; page: number }>()
);
export const findUniversityPapersByUniversityIdsSuccess = createAction(
  '[Common ID Search] Find University Papers By University Ids Success',
  props<{ universities: CommonIdFindUniversityPapersResponse[] }>()
);
export const findUniversityPapersByUniversityIdsFailure = createAction(
  '[Common ID Search] Find University Papers By University Ids Failure'
);

// 検索条件に合う大学の詳細を取得する（都道府県別）  ------------------------------------------------------------
export const findUniversityPapersByPrefectureIds = createAction(
  '[Common ID Search] Find University Papers By Prefecture Ids',
  props<{ condition: UniversitySearchCondition<PrefectureCondition>; page: number }>()
);
export const findUniversityPapersByPrefectureIdsSuccess = createAction(
  '[Common ID Search] Find University Papers By Prefecture Ids Success',
  props<{ universities: CommonIdFindUniversityPapersResponse[] }>()
);
export const findUniversityPapersByPrefectureIdsFailure = createAction(
  '[Common ID Search] Find University Papers By Prefecture Ids Failure'
);

// 検索結果の校数をリセットする場合 ----------------------------------------------------------------------------------
export const initializeUniversityCountState = createAction('[Common ID Search] Initialize University Count State');

// 検索結果の大学詳細をリセットする場合 ----------------------------------------------------------------------------------
export const initializeUniversityPapersState = createAction('[Common ID Search] Initialize University Paper State');
